import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { RejectApplicationRequest } from '@nucleus-commerce/api-client/platform';

import { applicationsApi } from '../api/applications-api';

import { applicationKeys } from './application-keys';

export function useRejectApplication(id: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: RejectApplicationRequest) => applicationsApi.reject(id, body),
    meta: { successMessage: 'applications:toasts.rejected' },
    onSuccess: (application) => {
      queryClient.setQueryData(applicationKeys.detail(id), application);
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: applicationKeys.lists() }),
        queryClient.invalidateQueries({ queryKey: applicationKeys.counts() }),
      ]);
    },
  });
}
